import { copy } from "../copy";
import { executorStatusLine, typeCovered } from "../domain/executors";
import { taskStatusLine, tasksForAccount } from "../domain/tasks";
import { formatWhen } from "../lib/format";
import { useApp } from "../state/store";
import { useState } from "react";

export function Tasks() {
  const app = useApp();
  const executors = app.state.executors ?? [];
  const tasks = tasksForAccount(app.state.tasks ?? [], app.accountId).sort((left, right) => right.createdAt.localeCompare(left.createdAt));
  const [waking, setWaking] = useState("");
  return (
    <div className="stack">
      <section className="panel desk" aria-label="执行者">
        {executors.length === 0 ? (
          <p className="desk-line">
            <b>{copy.tasks.noExecutor}</b>
            <button type="button" className="text-action" onClick={() => app.navigate("settings", "section=executors")}>{copy.executors.open}</button>
          </p>
        ) : executors.map((executor) => (
          <p key={executor.id} className="desk-line">
            <b>{executor.name}</b>
            <span>{executorStatusLine(executor)}</span>
          </p>
        ))}
      </section>
      {tasks.length === 0 ? (
        <section className="panel empty-card">
          <h2>{copy.tasks.empty}</h2>
          <p>{copy.tasks.emptyLead}</p>
          <ol className="steps">
            {copy.tasks.steps.map((step, index) => (
              <li key={step}>
                <b>{index + 1}</b>
                <span>{step}</span>
              </li>
            ))}
          </ol>
          <button type="button" className="button primary" onClick={() => app.navigate("inbox", "tab=find")}>{copy.find.open}</button>
        </section>
      ) : (
        <>
          <div className="library-bar">
            <span />
            <button type="button" className="button primary" onClick={() => app.navigate("inbox", "tab=find")}>{copy.find.open}</button>
          </div>
          <section className="panel table-panel">
            <div className="task-list">
              <div className="task-row task-head">
                <span>{copy.tasks.columns.type}</span>
                <span>{copy.tasks.columns.status}</span>
                <span>{copy.tasks.columns.platforms}</span>
                <span>{copy.tasks.columns.created}</span>
              </div>
              {tasks.map((task) => {
                const line = taskStatusLine(task, app.agentReady, typeCovered(executors, task.type));
                const claimer = executors.find((item) => item.id === task.claimedBy);
                const showClaimer = Boolean(claimer) && (task.status === "进行中" || task.status === "已完成" || task.status === "失败");
                return (
                  <div key={task.id} className="task-row">
                    <span>{task.type}</span>
                    <div className="task-status">
                      <span className="status-line" title={line}>{line}</span>
                      {showClaimer && claimer ? <span className="muted">{claimer.name}</span> : null}
                      {task.status === "排队" ? (
                        <button
                          type="button"
                          className="button line"
                          disabled={waking === task.id}
                          onClick={() => {
                            setWaking(task.id);
                            void app.rewakeTask(task.id).finally(() => setWaking(""));
                          }}
                        >
                          {copy.tasks.rewake}
                        </button>
                      ) : null}
                    </div>
                    <span className="clip">{task.platforms.join("、") || copy.dash}</span>
                    <span className="clip">{formatWhen(task.createdAt)}</span>
                  </div>
                );
              })}
            </div>
          </section>
        </>
      )}
    </div>
  );
}
